export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const USER_SET = 'USER_SET';
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const SET_USER_COMPANIES = 'SET_USER_COMPANIES';